/* vitae · cart tools: quick-add search + share dialog (cart and product, with a QR) + Bulbsharing pair fixes.
   Markup: snippets/vitae-cart-tools.liquid (rendered by cart-drawer and main-cart). Styles: vitae-cart.css.
   Uses only Shopify's storefront endpoints (predictive search, product .js, cart add/update) and the
   theme's own cartUpdate pubsub, so the drawer, cart page and cart count refresh the usual way.
   Share link format = ua-core pattern cart-share-permalink (simple variant): /cart/clear → /cart/add → /cart. */
(() => {
  'use strict';
  if (window.__vitaeCart) return;
  window.__vitaeCart = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const SHARE_MAX = 7000;               // longer links hit the server's URL limit
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };

  /* The cart re-renders its own HTML after every change; this survives it. */
  const state = { q: '', focus: false, note: '' };
  const products = new Map();

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); } catch (e) { return (cents / 100).toFixed(2); }
  };
  /* Liquid's `t` filter HTML-escapes its output (' → &#39;), so decode once; esc() re-escapes on output. */
  const decode = (s) => { const ta = document.createElement('textarea'); ta.innerHTML = s; return ta.value; };
  const strings = () => {
    const out = {};
    document.querySelectorAll('script[data-vc-strings]').forEach((el) => {
      try {
        const raw = JSON.parse(el.textContent);
        Object.keys(raw).forEach((k) => { out[k] = decode(raw[k]); });
      } catch (e) { /* ignore */ }
    });
    return out;
  };
  const t = (key, vars) => {
    let s = strings()[key] || key;
    Object.keys(vars || {}).forEach((k) => { s = s.replace('[' + k + ']', vars[k]); });
    return s;
  };
  const product = (handle) => {
    if (!products.has(handle)) {
      products.set(handle, fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null)).catch(() => null));
    }
    return products.get(handle);
  };
  const imgUrl = (src, w) => {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };
  const sectionIds = () => Array.from(new Set(Array.from(
    document.querySelectorAll('cart-items[data-section-id], cart-drawer[data-section-id], main-cart[data-section-id]')
  ).map((el) => el.dataset.sectionId)));

  /* ---------------------------------------------------------------- add to cart */

  async function addVariant(variantId) {
    const add = await fetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
    const added = await add.json();
    if (!add.ok) throw new Error(added.description || added.message || 'add failed');
    await refreshCart();
  }

  async function refreshCart() {
    if (!document.querySelector('cart-items')) { window.location.reload(); return; } // cart page, was empty

    // Full cart plus freshly rendered sections, in the shape the theme's cart code expects.
    const upd = await fetch(root + 'cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ sections: sectionIds(), sections_url: window.location.pathname }) });
    const cart = await upd.json();
    if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'vitae-cart', cart });
  }

  /* ---------------------------------------------------------------- quick add */

  class VitaeQuickAdd extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.vc-qa__input');
      this.results = this.querySelector('.vc-qa__results');
      this.status = this.querySelector('.vc-qa__status');
      this.clearBtn = this.querySelector('.vc-qa__clear');
      if (!this.input) return;
      this.linkOnly = new Set((this.dataset.linkOnly || '').split(',').filter(Boolean));
      this.items = [];
      this.sel = -1;
      this.seq = 0;
      this.busy = false;

      this.input.value = state.q;
      this.clearBtn.hidden = !state.q;
      if (state.note) this.say(state.note);
      if (state.focus) requestAnimationFrame(() => this.focusInput());

      this.input.addEventListener('input', () => {
        state.q = this.input.value;
        this.clearBtn.hidden = !state.q;
        clearTimeout(this.timer);
        const term = state.q.trim();
        if (term.length < 2) { this.seq++; this.close(); return; }
        this.timer = setTimeout(() => this.search(term), 220);
      });
      this.input.addEventListener('focus', () => {
        state.focus = true;
        if (state.q.trim().length >= 2 && !this.items.length) this.search(state.q.trim());
      });
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.addEventListener('click', (e) => this.onClick(e));
      this.outside = (e) => { if (!this.contains(e.target)) { state.focus = false; this.close(); } };
      document.addEventListener('click', this.outside);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('click', this.outside);
    }

    focusInput() {
      try {
        this.input.focus({ preventScroll: true });
        this.input.setSelectionRange(this.input.value.length, this.input.value.length);
      } catch (e) { /* ignore */ }
    }

    say(text) {
      state.note = text;
      this.status.textContent = text;
      this.status.hidden = !text;
      clearTimeout(VitaeQuickAdd.noteTimer);
      if (text) VitaeQuickAdd.noteTimer = setTimeout(() => { state.note = ''; document.querySelectorAll('.vc-qa__status').forEach((s) => { s.hidden = true; }); }, 4000);
    }

    close() {
      this.items = [];
      this.sel = -1;
      this.results.hidden = true;
      this.results.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
    }

    message(text) {
      this.results.innerHTML = '<div class="vc-qa__msg">' + esc(text) + '</div>';
      this.results.hidden = false;
    }

    search(term) {
      const n = ++this.seq;
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((j) => {
          if (n !== this.seq) return;
          this.items = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          this.sel = this.items.length ? 0 : -1;
          this.render();
        })
        .catch(() => { if (n === this.seq) this.message(t('search_error')); });
    }

    render() {
      if (!this.items.length) { this.message(t('no_results')); return; }
      this.results.innerHTML = this.items.map((p, i) =>
        '<div class="vc-qa__row' + (i === this.sel ? ' is-sel' : '') + '" data-handle="' + esc(p.handle) + '" role="option">' +
          '<button type="button" class="vc-qa__main" data-act="pick">' +
            '<span class="vc-qa__img">' + (p.image ? '<img src="' + esc(imgUrl(p.image, 120)) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
            '<span class="vc-qa__meta"><span class="vc-qa__title">' + esc(p.title) + '</span><span class="vc-qa__sub" data-sub></span></span>' +
            '<span class="vc-qa__cta" data-cta aria-hidden="true">+</span>' +
          '</button>' +
          '<div class="vc-qa__variants" data-variants hidden></div>' +
        '</div>').join('');
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.items.forEach((p) => this.hydrate(p.handle));
    }

    row(handle) {
      return Array.from(this.results.querySelectorAll('.vc-qa__row')).find((r) => r.dataset.handle === handle);
    }

    /* Exact prices and variants come from the product JSON, never guessed from the search result. */
    hydrate(handle) {
      product(handle).then((p) => {
        const row = this.row(handle);
        if (!p || !row) return;
        const sub = row.querySelector('[data-sub]');
        const cta = row.querySelector('[data-cta]');
        const many = p.variants.length > 1;
        const linkOnly = p.requires_selling_plan || this.linkOnly.has(handle);
        const from = many && p.price_varies ? t('from') + ' ' : '';
        sub.innerHTML = from + money(p.price) + (many ? ' · ' + esc(t('variants', { count: p.variants.length })) : '');
        if (!p.available) { sub.innerHTML += ' · ' + esc(t('sold_out')); row.classList.add('is-out'); }
        row.dataset.mode = linkOnly ? 'link' : (many ? 'variants' : 'add');
        cta.textContent = linkOnly ? '→' : (many ? '⌄' : '+');
        row.querySelector('.vc-qa__main').setAttribute('aria-label',
          p.title + ': ' + (linkOnly ? t('view') : many ? t('choose_variant') : t('add')));
      });
    }

    mark() {
      this.results.querySelectorAll('.vc-qa__row').forEach((r, i) => r.classList.toggle('is-sel', i === this.sel));
      const el = this.results.querySelectorAll('.vc-qa__row')[this.sel];
      if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    onKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!this.items.length) return;
        e.preventDefault();
        this.sel = (this.sel + (e.key === 'ArrowDown' ? 1 : -1) + this.items.length) % this.items.length;
        this.mark();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        const p = this.items[this.sel < 0 ? 0 : this.sel];
        if (p) this.pick(p.handle);
      } else if (e.key === 'Escape') {
        if (!this.results.hidden) { e.stopPropagation(); this.close(); }
      }
    }

    onClick(e) {
      if (e.target.closest('.vc-qa__clear')) { state.q = ''; this.input.value = ''; this.clearBtn.hidden = true; this.seq++; this.close(); this.focusInput(); return; }
      const variant = e.target.closest('[data-variant]');
      if (variant) { this.add(Number(variant.dataset.variant), variant.dataset.title); return; }
      const main = e.target.closest('[data-act="pick"]');
      if (main) this.pick(main.closest('.vc-qa__row').dataset.handle);
    }

    pick(handle) {
      if (this.busy) return;
      product(handle).then((p) => {
        const row = this.row(handle);
        if (!p || !row) { this.say(t('search_error')); return; }
        const mode = row.dataset.mode;
        if (mode === 'link') { window.location.href = root + 'products/' + handle; return; }
        if (mode === 'variants') {
          const box = row.querySelector('[data-variants]');
          if (!box.hidden) { box.hidden = true; return; }
          box.innerHTML = p.variants.map((v) =>
            '<button type="button" class="vc-qa__chip" data-variant="' + v.id + '" data-title="' + esc(p.title + ' · ' + v.title) + '"' + (v.available ? '' : ' disabled') + '>' +
              esc(v.title) + (p.price_varies ? ' <small>' + money(v.price) + '</small>' : '') + '</button>').join('');
          box.hidden = false;
          const first = box.querySelector('button:not([disabled])');
          if (first) first.focus();
          return;
        }
        const v = p.variants.filter((x) => x.available)[0];
        if (!v) { this.say(t('sold_out')); return; }
        this.add(v.id, p.title);
      });
    }

    add(variantId, title) {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-busy');
      state.focus = true;
      state.q = '';
      addVariant(variantId)
        .then(() => { state.note = t('added', { title }); })
        .catch((err) => { state.note = (err && err.message && err.message !== 'add failed') ? err.message : t('add_error'); })
        .then(() => {
          this.busy = false;
          // The theme usually re-renders the cart, so talk to whichever element is on the page now.
          document.querySelectorAll('vitae-quick-add').forEach((el) => {
            if (!el.input) return;
            el.classList.remove('is-busy');
            el.input.value = '';
            el.clearBtn.hidden = true;
            el.close();
            el.say(state.note);
            el.focusInput();
          });
        });
    }
  }
  if (!customElements.get('vitae-quick-add')) customElements.define('vitae-quick-add', VitaeQuickAdd);

  /* ---------------------------------------------------------------- bulbsharing pairs */
  /* snippets/vitae-rent-guard.liquid renders the notice (data-vc-rent) and turns checkout off while a deposit
     and its monthly fee differ in quantity; these buttons even them out. */

  async function rentAdd(btn) {
    const item = { id: Number(btn.dataset.vcRentAdd), quantity: Number(btn.dataset.qty) || 1 };
    if (btn.dataset.plan) item.selling_plan = Number(btn.dataset.plan);
    const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [item] }) });
    if (!res.ok) throw new Error('add failed');
  }

  async function rentReduce(btn) {
    // "key:qty,key:qty," — take the extra quantity off the last lines first.
    const lines = btn.dataset.vcRentReduce.split(',').filter(Boolean).map((s) => {
      const i = s.lastIndexOf(':');
      return { key: s.slice(0, i), qty: Number(s.slice(i + 1)) };
    }).reverse();
    let left = Number(btn.dataset.qty) || 0;
    for (const line of lines) {
      if (left <= 0) break;
      const take = Math.min(left, line.qty);
      const res = await fetch(root + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: line.key, quantity: line.qty - take }) });
      if (!res.ok) throw new Error('change failed');
      left -= take;
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-vc-rent-add], [data-vc-rent-reduce]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const box = btn.closest('[data-vc-rent]');
    box.querySelectorAll('button').forEach((b) => { b.disabled = true; });
    (btn.hasAttribute('data-vc-rent-add') ? rentAdd(btn) : rentReduce(btn))
      .then(refreshCart)
      .catch(() => {
        box.querySelectorAll('button').forEach((b) => { b.disabled = false; });
        const status = box.querySelector('[data-vc-rent-status]');
        if (status) { status.textContent = t('rent_fix_error'); status.hidden = false; }
      });
  });

  /* Belt and braces: the checkout button is rendered disabled, but never let a checkout submit through. */
  document.addEventListener('submit', (e) => {
    if (!e.submitter || e.submitter.name !== 'checkout' || !document.querySelector('[data-vc-rent]')) return;
    e.preventDefault();
    const box = document.querySelector('[data-vc-rent]');
    if (box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);

  /* ---------------------------------------------------------------- share */

  function buildPermalink(cart) {
    const params = new URLSearchParams();
    cart.items.forEach((item) => {
      params.append('items[][id]', String(item.variant_id || item.id));
      params.append('items[][quantity]', String(item.quantity));
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        params.append('items[][selling_plan]', String(item.selling_plan_allocation.selling_plan.id));
      }
      Object.keys(item.properties || {}).forEach((key) => {
        if (key.charAt(0) === '_') return; // hidden properties stay private
        const value = item.properties[key];
        if (value === null || value === undefined || value === '') return;
        params.append('items[][properties][' + key + ']', String(value));
      });
    });
    params.append('return_to', root + 'cart');
    const addUrl = root + 'cart/add?' + params.toString();
    return window.location.origin + root + 'cart/clear?return_to=' + encodeURIComponent(addUrl);
  }

  async function copyText(text) {
    try { if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(text); return true; } } catch (e) { /* fall through */ }
    const ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0';
    document.body.appendChild(ta); ta.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { /* ignore */ }
    document.body.removeChild(ta);
    return ok;
  }

  /* ---------------------------------------------------------------- QR (showroom iPads: turn the screen round, the customer scans) */

  const QR_DENSE = 1200;  // bytes: past this the code is dense, so a hint offers zoom / AirDrop / e-mail
  const QR_MAX = 2953;    // QR version 40, error level L, byte mode: past this no code fits
  let qrLoad = null;
  let qrSeq = 0;

  /* assets/vitae-qr.js (global `qrcode`) loads on the first open only; its URL comes from Liquid (data-vc-qr). */
  function loadQr() {
    if (window.qrcode) return Promise.resolve();
    if (!qrLoad) {
      const el = document.querySelector('[data-vc-qr]');
      if (!el) return Promise.reject(new Error('no qr src'));
      qrLoad = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = el.dataset.vcQr;
        s.async = true;
        s.onload = () => (window.qrcode ? resolve() : reject(new Error('no qrcode')));
        s.onerror = reject;
        document.head.appendChild(s);
      }).catch((err) => { qrLoad = null; throw err; });
    }
    return qrLoad;
  }

  /* Black on white whatever the sky band, 4-module quiet zone, one path of horizontal runs. Throws when the text doesn't fit. */
  function qrSvg(text) {
    const q = window.qrcode(0, 'L');
    q.addData(text);
    q.make();
    const n = q.getModuleCount();
    const size = n + 8;
    let d = '';
    for (let r = 0; r < n; r++) {
      for (let c = 0; c < n; c++) {
        if (!q.isDark(r, c)) continue;
        let run = 1;
        while (c + run < n && q.isDark(r, c + run)) run++;
        d += 'M' + (c + 4) + ' ' + (r + 4) + 'h' + run + 'v1h-' + run + 'z';
        c += run - 1;
      }
    }
    return '<svg viewBox="0 0 ' + size + ' ' + size + '" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges" aria-hidden="true" focusable="false">' +
      '<rect width="' + size + '" height="' + size + '" fill="#fff"/><path d="' + d + '" fill="#000"/></svg>';
  }

  function drawQr(d, url) {
    const box = d.querySelector('.vc-dialog__qr');
    const code = d.querySelector('.vc-dialog__qr-code');
    const hint = d.querySelector('.vc-dialog__qr-hint');
    const seq = ++qrSeq;
    box.hidden = true;
    code.innerHTML = '';
    hint.hidden = true;
    if (!url) return;
    const bytes = new TextEncoder().encode(url).length;
    const say = (key) => { hint.textContent = t(key); hint.hidden = false; };
    if (bytes > QR_MAX) { say('qr_too_long'); return; }
    loadQr().then(() => {
      if (seq !== qrSeq) return;
      try { code.innerHTML = qrSvg(url); } catch (e) { say('qr_too_long'); return; }
      box.hidden = false;
      if (bytes > QR_DENSE) say('qr_dense');
    }).catch(() => { /* no code; the link and buttons still work */ });
  }

  /* ---------------------------------------------------------------- share dialog (cart + product) */

  let dialog = null;
  let current = { subject: '', url: '' };
  function shareDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'vc vc-dialog';
    dialog.innerHTML =
      '<form method="dialog" class="vc-dialog__box">' +
        '<button class="vc-dialog__x" value="close" aria-label="' + esc(t('close')) + '">×</button>' +
        '<h2 class="vc-dialog__title"></h2>' +
        '<p class="vc-dialog__hint"></p>' +
        '<input class="vc-dialog__link" type="text" readonly>' +
        '<div class="vc-dialog__actions">' +
          '<button type="button" class="vc-btn vc-btn--primary" data-vc-copy>' + esc(t('copy')) + '</button>' +
          (navigator.share ? '<button type="button" class="vc-btn" data-vc-native>' + esc(t('share_native')) + '</button>' : '') +
          '<a class="vc-btn" data-vc-mail>' + esc(t('email')) + '</a>' +
        '</div>' +
        '<p class="vc-dialog__msg" role="status" aria-live="polite" hidden></p>' +
        '<figure class="vc-dialog__qr" hidden>' +
          '<span class="vc-dialog__qr-code"></span>' +
        '</figure>' +
        '<p class="vc-dialog__qr-hint" hidden></p>' +
      '</form>';
    document.body.appendChild(dialog);
    // A tap anywhere outside the white box (the dimmed backdrop) closes it.
    dialog.addEventListener('click', (e) => { if (!e.target.closest('.vc-dialog__box')) dialog.close(); });
    dialog.querySelector('.vc-dialog__link').addEventListener('focus', (e) => e.target.select());
    dialog.querySelector('[data-vc-copy]').addEventListener('click', async (e) => {
      const ok = await copyText(dialog.querySelector('.vc-dialog__link').value);
      const msg = dialog.querySelector('.vc-dialog__msg');
      msg.textContent = ok ? t('copied') : t('copy_failed');
      msg.hidden = false;
      e.target.textContent = ok ? t('copied') : t('copy');
      setTimeout(() => { e.target.textContent = t('copy'); msg.hidden = true; }, 2500);
    });
    const native = dialog.querySelector('[data-vc-native]');
    if (native) native.addEventListener('click', () => {
      navigator.share({ title: current.subject, url: current.url }).catch(() => {});
    });
    return dialog;
  }

  /* One dialog for both: { url, title, hint, subject, body, note }. An empty url shows only the note. */
  function showShare(o) {
    const d = shareDialog();
    const msg = d.querySelector('.vc-dialog__msg');
    const link = d.querySelector('.vc-dialog__link');
    const url = o.url || '';
    current = { subject: o.subject, url };
    d.querySelector('.vc-dialog__title').textContent = o.title;
    d.querySelector('.vc-dialog__hint').textContent = o.hint;
    link.setAttribute('aria-label', o.title);
    msg.textContent = o.note || '';
    msg.hidden = !o.note;
    link.value = url;
    link.hidden = !url;
    d.querySelector('.vc-dialog__actions').hidden = !url;
    d.querySelector('[data-vc-mail]').href = 'mailto:?subject=' + encodeURIComponent(o.subject) + '&body=' + encodeURIComponent(o.body + '\n\n' + url);
    drawQr(d, url);
    if (d.open) return;
    if (d.showModal) d.showModal(); else if (url) copyText(url);
  }

  async function openCartShare(button) {
    button.setAttribute('aria-busy', 'true');
    try {
      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      let url = '';
      let note = '';
      if (!cart.items || !cart.items.length) note = t('share_empty');
      else {
        url = buildPermalink(cart);
        if (url.length > SHARE_MAX) { url = ''; note = t('share_too_long'); }
      }
      showShare({ url, note, title: t('share_title'), hint: t('share_hint'), subject: t('email_subject'), body: t('email_body') });
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  /* Clean product link: origin + locale root + product path (+ the chosen variant). Never the address bar's
     query, so utm, fbclid and preview_theme_id don't travel. The variant must belong to this product. */
  function productLink(button) {
    const ids = (button.dataset.variants || '').split(',').filter(Boolean);
    const candidates = [];
    const form = button.dataset.form && document.getElementById(button.dataset.form);
    if (form) form.querySelectorAll('[name="id"]').forEach((el) => candidates.push(el.value));
    const scope = button.closest('.shopify-section') || document;
    scope.querySelectorAll('[name="id"]').forEach((el) => candidates.push(el.value));
    candidates.push(new URLSearchParams(window.location.search).get('variant'));
    const variant = candidates.find((v) => v && ids.indexOf(String(v)) > -1);
    return window.location.origin + root + 'products/' + encodeURIComponent(button.dataset.handle) +
      (variant && ids.length > 1 ? '?variant=' + variant : '');
  }

  function openProductShare(button) {
    const title = button.dataset.title || '';
    showShare({
      url: productLink(button),
      title: t('share_product_title'),
      hint: t('share_product_hint'),
      subject: title,
      body: t('share_product_body', { title }),
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-vc-share]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.vcShare === 'product') openProductShare(btn); else openCartShare(btn);
  });
})();
